<script setup>
import ActionButton from "@js/components/ActionButton.vue";
import Modal from "@js/components/Modal.vue";
import { useRoute } from "@js/utils/route";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { semEvent, tenant, callback } = defineProps({
  semEvent: {
    type: Object,
    required: true,
  },
  tenant: {
    type: Object,
    required: false,
  },
  callback: {
    type: Function,
    required: false,
  },
});

const { route } = useRoute();

const deleteButtonRef = ref(null);

const isOpen = ref(false);

function setIsOpen(value) {
  isOpen.value = value;
}

function deleteAction() {
  fetch(
    route("front.projectManagement.sem.deleteEvent", {
      tenant: tenant.id,
      semEventId: semEvent.id,
    }),
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-TOKEN": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
    },
  )
    .then(() => {
      setIsOpen(false);

      if (callback) {
        callback();
      }
    })
    .catch((error) => {
      console.error(error);
    });
}
</script>

<template>
  <slot name="button" :set-is-open="setIsOpen" />

  <Modal
    :is-open="isOpen"
    :set-is-open="setIsOpen"
    size="small"
    :initial-focus="deleteButtonRef"
  >
    <template #title>
      {{
        t("title.deleteEvent", {
          id: semEvent.id,
        })
      }}
    </template>

    <template #content>
      {{
        t("text.areYouSureToDeleteEvent", {
          id: semEvent.id,
        })
      }}
    </template>

    <template #footer>
      <div class="flex justify-end gap-2">
        <ActionButton type="transparent" :callback="() => setIsOpen(false)">
          {{ t("button.cancel") }}
        </ActionButton>

        <ActionButton
          ref="deleteButtonRef"
          type="danger"
          :callback="() => deleteAction()"
        >
          {{ t("button.delete") }}
        </ActionButton>
      </div>
    </template>
  </Modal>
</template>
